import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderWidth,
  borderStyle,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Pill = styled.button<{ $isSelected: boolean; $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  padding: ${spacing[1]} ${spacing[3]};
  border-radius: 30px;
  border: ${borderWidth[1]} ${borderStyle.solid}
    ${({ $isSelected, $disabled }) =>
      $disabled
        ? rawColors.grey[200]
        : $isSelected
          ? rawColors.primary[500]
          : rawColors.grey[300]};
  background: ${({ $isSelected, $disabled }) =>
    $disabled
      ? rawColors.grey[100]
      : $isSelected
        ? rawColors.primary[100]
        : rawColors.structural.white};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ $isSelected }) =>
      $isSelected ? rawColors.primary[500] : rawColors.grey[500]};
  }
`;

export const Label = styled.span<{ $isSelected: boolean; $disabled?: boolean }>`
${($isSelected) => ($isSelected ? typographyMixin("caption", 3) : typographyMixin("caption", 4))}
  color: ${({ $isSelected, $disabled }) =>
    $disabled
      ? rawColors.text.lowEmphasis
      : $isSelected
        ? rawColors.primary[500]
        : rawColors.text.mediumEmphasis};
`;

export const Dot = styled.span<{ $color: string; $isSelected: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ $color }) => $color};
`;
